// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"8b47b4ac","123":"853f2aa4","424":"280abd7a","857":"994a5c2c","923":"36d38add","950":"c90ab8ac"}[chunkId] + ".chunk.js";
};